import { IntegrityMonitorPauseWebComponent } from './component/IntegrityMonitorPauseWebComponents';
import { WEB_COMPONENT_INTEGRITY_MONITOR_PAUSE } from '../../webcomponents.constants';

export { IntegrityMonitorPauseWebComponent };

window.customElements.define(WEB_COMPONENT_INTEGRITY_MONITOR_PAUSE, IntegrityMonitorPauseWebComponent);
